/** Count explicit line breaks before wrapping: drawText must receive one line at a time. */
export function wrapPdfLines(text: string, measure: (text: string) => number, width: number): string[] {
  return text.replace(/\r\n?/g, '\n').split('\n').flatMap((paragraph) => {
    const result: string[] = []; let line = '';
    for (const character of paragraph.replace(/\t/g, '    ')) {
      if (line && measure(line + character) > width) { result.push(line); line = character; }
      else line += character;
    }
    result.push(line); return result;
  });
}
